import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import GeoUtils from '../geoUtils.js';

export default class NodeApplyUVs extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);		

		this.addInput(PARAM_TYPE.FLOAT, 'u_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'v_offset', 0.0, { minValue: -1, maxValue: 1, units: PARAM_UNITS.METERS });

		this.addInput(PARAM_TYPE.FLOAT, 'uv_rotation', 0.0, { minValue: -180, maxValue: 180, units: PARAM_UNITS.DEGREES });

		this.addInput(PARAM_TYPE.BBOX, 'relative_to', null);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'applyUVs';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		GeoUtils.applyBoxUVsToMeshes(pGeoList, inputValues['u_offset'], inputValues['v_offset'], inputValues['uv_rotation'], inputValues['relative_to']);
		return pGeoList;
	}
}